export enum ResourceMode {
  Create,
  Edit,
  Patch
}
